import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';
import { GenericSelect } from '../../components';
import { useContractActions } from '../../context/ContractActionContext';
import { Actions } from '../../stores/ActionStore';


const PremiumWithdrawalCalculationMethodInput: InputWithSource = ({ input }) => {
    const contractActions = useContractActions();

    return (
        <GenericSelect
            label={input.name}
            input={input}
            onChange={() => contractActions.dispatch(Actions.RebuildNodes)}
        />
    );
};

PremiumWithdrawalCalculationMethodInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(PremiumWithdrawalCalculationMethodInput);
